<template>
  <grid ref="grid" :config="gridConfig" class="no-grid-border"/>
</template>

<script>
import gridConfig from './GridConfig'
import mixin from './../mixin.js'
export default {
  name: 'TabStockPn',
  mixins: [mixin],
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  methods: {
    loadData (grid) {
      let filters = `tagInfoCompanyID==${this.filterID}`
      grid.setFilters(filters)
      grid.loadData()
    }
  }
}
</script>
